<section class="flex flex-column consult__section">
  <div class="col-12inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label for="additionalInfo_{{turn}}" class="no-margin">{{screen.labels.additionalInformation.heading}}</label>
    </h2>
    <span class="consult__section-help">{{screen.labels.additionalInformation.help}}</span>
  </div>

  <div class="col-12 px-0 inline-flex consult__section-input-group">
    <textarea pInputTextarea name="additionalInfo_{{turn}}" [(ngModel)]="value" [rows]="4" validation
      [readonly]="readonly" class="uppercase no-margin"></textarea>
  </div>
</section>